// extracted by mini-css-extract-plugin
export default {"Container":"ExpressCheckout_Container__Ph7mO","ReservationInfo":"ExpressCheckout_ReservationInfo__Zhr+k"};